import api from './client';

export interface NotificationChannel {
  id: string;
  label: string;
  kind: string;
  chat_id: string;
  enabled: number;
  is_forum: number;
  thread_reg: number | null;
  thread_dep: number | null;
  thread_cap: number | null;
  thread_ban: number | null;
  thread_summary: number | null;
  thread_daily: number | null;
  thread_offers: number | null;
  thread_updates: number | null;
  thread_releases: number | null;
  thread_lowreg: number | null;
  thread_localization: number | null;
  thread_deletions: number | null;
  cap_threshold_pct: number;
  owner_admin_id: string | null;
  owner_name?: string | null;
  owner_email?: string | null;
  scope_mode?: 'owner_apps' | 'owner_campaigns' | 'global' | 'legacy_apps';
  legacy_app_count?: number;
  created_at: string;
}

export interface NotificationRule {
  id: string;
  event_type: 'dep' | 'reg' | 'all' | 'ban' | 'summary' | 'summary';
  channel_id: string;
  enabled: number;
  created_at: string;
  channel_label?: string;
  channel_chat_id?: string;
}

export interface NotificationConfig {
  has_token: boolean;
  token_preview: string;
  enabled: boolean;
}

export interface ChannelInput {
  owner_admin_id?: string | null;
  label?: string;
  chat_id?: string;
  kind?: string;
  enabled?: boolean;
  is_forum?: boolean;
  thread_reg?: number | null;
  thread_dep?: number | null;
  thread_cap?: number | null;
  thread_ban?: number | null;
  thread_summary?: number | null;
  thread_daily?: number | null;
  thread_offers?: number | null;
  thread_updates?: number | null;
  thread_releases?: number | null;
  thread_lowreg?: number | null;
  thread_localization?: number | null;
  cap_threshold_pct?: number;
}

export const getNotificationChannels = () => api.get<NotificationChannel[]>('/admin/notifications/channels');
export const createNotificationChannel = (data: ChannelInput & { label: string; chat_id: string }) =>
  api.post<NotificationChannel>('/admin/notifications/channels', data);
export const updateNotificationChannel = (id: string, data: ChannelInput) =>
  api.put<NotificationChannel>(`/admin/notifications/channels/${id}`, data);
export const deleteNotificationChannel = (id: string) =>
  api.delete<{ message: string }>(`/admin/notifications/channels/${id}`);

export const getNotificationRules = () => api.get<NotificationRule[]>('/admin/notifications/rules');
export const createNotificationRule = (data: { event_type: 'dep' | 'reg' | 'all' | 'ban' | 'summary'; channel_id: string; enabled?: boolean }) =>
  api.post<NotificationRule>('/admin/notifications/rules', data);
export const updateNotificationRule = (id: string, data: Partial<{ event_type: 'dep' | 'reg' | 'all' | 'ban' | 'summary'; channel_id: string; enabled: boolean }>) =>
  api.put<NotificationRule>(`/admin/notifications/rules/${id}`, data);
export const deleteNotificationRule = (id: string) =>
  api.delete<{ message: string }>(`/admin/notifications/rules/${id}`);

export const getNotificationConfig = () => api.get<NotificationConfig>('/admin/notifications/config');
export const updateNotificationConfig = (data: { bot_token?: string; enabled?: boolean }) =>
  api.put<{ message: string }>('/admin/notifications/config', data);

export const testNotificationChannel = (data: { channel_id: string; message?: string; topic?: 'reg' | 'dep' | 'cap' | 'ban' | 'summary' | 'daily' }) =>
  api.post<{ message: string }>('/admin/notifications/test', data);
